import type { SupportedLocale } from '@erp/shared';

export const deliveryToursTranslations = {
  de: {
    tours: {
      title: 'Liefertouren',
      driverTitle: 'Meine Liefertouren',
      new: 'Tour anlegen',
      name: 'Bezeichnung',
      date: 'Datum',
      driver: 'Fahrer',
      vehicle: 'Fahrzeug (optional)',
      capacity: 'Kapazität in kg',
      packageCapacity: 'Gebindekapazität',
      start: 'Startpunkt',
      end: 'Endpunkt',
      latitude: 'Breitengrad',
      longitude: 'Längengrad',
      departure: 'Abfahrtszeit',
      empty: 'Keine Touren vorhanden.',
      loading: 'Touren werden geladen …',
      retry: 'Erneut laden',
      error: 'Die Aktion ist fehlgeschlagen. Angaben bleiben erhalten.',
      save: 'Speichern',
      saved: 'Gespeichert',
      cancel: 'Abbrechen',
      open: 'Öffnen',
      assign: 'Lieferung zuordnen',
      source: 'Auftrag oder Lieferschein',
      orderDraftHint:
        'Aufträge erzeugen einen verknüpften Lieferentwurf. Vor Tourstart kommissionieren und Warenausgang buchen.',
      quantity: 'Menge in Basiseinheit',
      planned: 'Geplant',
      delivered: 'Geliefert',
      damaged: 'Beschädigt',
      reason: 'Abweichungsgrund',
      notes: 'Hinweise',
      windowFrom: 'Warenannahme ab',
      windowUntil: 'Warenannahme bis',
      duration: 'Aufenthalt in Minuten',
      up: 'Stopp nach oben',
      down: 'Stopp nach unten',
      optimize: 'Reihenfolge optimieren',
      check: 'Planung prüfen',
      conflicts: 'Planungshinweise',
      startTour: 'Tour starten',
      closeTour: 'Tour beenden',
      enRoute: 'Unterwegs',
      arrived: 'Angekommen',
      failed: 'Lieferung fehlgeschlagen',
      navigate: 'Navigation öffnen',
      proof: 'Lieferbestätigung',
      recipient: 'Empfängername',
      signature: 'Unterschrift (optional)',
      clearSignature: 'Unterschrift löschen',
      photo: 'Foto hinzufügen',
      photos: 'Fotos',
      photoUnsent: 'Foto lokal gespeichert · wartet auf Upload',
      photoUploaded: 'Foto hochgeladen · Liefernachweis noch nicht bestätigt',
      photoNotStored:
        'Foto nicht auf diesem Gerät gespeichert. Seite offen lassen und erneut versuchen oder verwerfen.',
      photoRetry: 'Foto speichern und erneut übertragen',
      photoDiscard: 'Foto verwerfen',
      photoStorageFailed:
        'Fotos können auf diesem Gerät nicht gespeichert werden. Freien Speicher und Browsereinstellungen prüfen; Seite offen lassen.',
      photoLimit: 'Höchstens zehn Fotos mit jeweils bis zu 10 MB auswählen.',
      proofStorageFailed:
        'Angaben konnten nicht lokal gespeichert werden. Freien Speicher prüfen und erneut versuchen.',
      photoCleanupFailed: 'Liefernachweis bestätigt. Lokale Fotos konnten nicht entfernt werden.',
      photosLoading: 'Lokale Fotos werden wiederhergestellt …',
      gps: 'Standort für diesen Nachweis erfassen',
      saveLocal: 'Auf diesem Gerät speichern',
      unsent: 'Auf diesem Gerät gespeichert · noch nicht übertragen',
      confirmed: 'Vom Server bestätigter Liefernachweis',
      submit: 'Liefernachweis übertragen',
      noDoublePosting:
        'Die Bestätigung erzeugt keinen weiteren Warenausgang und keine automatische Rechnung.',
      versionChanged: 'Die Tour wurde geändert. Angaben prüfen und den aktuellen Stand übernehmen.',
      refreshVersion: 'Aktuellen Stand übernehmen',
      containers: 'Gebinderücknahmen',
      containerType: 'Gebindeart',
      condition: 'Zustand',
      GOOD: 'Einwandfrei',
      DAMAGED: 'Beschädigt',
      history: 'Verlauf',
      settings: 'Lager und Lieferabläufe',
      manualRouting:
        'Manuelle Planung funktioniert ohne Anbieter. Für Straßenfahrzeiten benötigt der Betreiber einen eigenen oder vertraglich vereinbarten OSRM-Dienst. Kosten, Kartenaktualisierung, Profil und Limits legt der Betreiber fest. Kein öffentlicher Demo-Dienst wird automatisch genutzt.',
      routing: 'Straßenrouting',
      routingReady: 'Routingdienst eingerichtet',
      routingMissing: 'Betreiber muss TOUR_ROUTING_BASE_URL einrichten',
      gpsSetting: 'GPS nur bei ausdrücklicher Aktion am Liefernachweis erlauben',
      statuses: {
        PLANNED: 'Geplant',
        ACTIVE: 'Aktiv',
        COMPLETED: 'Beendet',
        CANCELLED: 'Aufgehoben',
        EN_ROUTE: 'Unterwegs',
        ARRIVED: 'Angekommen',
        DELIVERED: 'Geliefert',
        PARTIAL: 'Teilgeliefert',
        FAILED: 'Lieferung fehlgeschlagen',
      },
      planningConflicts: {
        MISSING_COORDINATES: 'Koordinaten fehlen',
        ADDRESS_INCOMPLETE: 'Adresse unvollständig',
        ROUTING_NOT_CONFIGURED: 'Keine Straßenfahrzeiten verfügbar',
        MISSING_DEPARTURE: 'Startpunkt oder Abfahrtszeit fehlt',
        TIME_WINDOW: 'Warenannahmezeit wird überschritten',
        CAPACITY: 'Fahrzeugkapazität überschritten',
        MISSING_WEIGHT: 'Gewicht nicht vollständig gepflegt',
        MISSING_PACKAGES: 'Bestätigte Gebindesumme fehlt',
        ROUTE_UNREACHABLE: 'Keine Straßenverbindung gefunden',
      },
      errors: {
        driver: 'Fahrer benötigt Tourenrecht.',
        version: 'Die Tour wurde geändert. Angaben prüfen und den aktuellen Stand übernehmen.',
        closed: 'Dieser Vorgang ist abgeschlossen.',
        started: 'Eine gestartete Tour kann nicht umgeplant werden.',
        source: 'Freigegebenen Auftrag oder offenen Lieferschein wählen.',
        overAllocated: 'Die Menge ist bereits einer Tour zugeordnet.',
        assignedDocument:
          'Dieser Lieferschein ist einer Tour zugeordnet. Zuerst den Stopp aus der Planung nehmen, dann Mengen, Chargen oder Lieferdaten ändern. Kommissionierung bleibt über den Lagerablauf möglich.',
        overDelivered: 'Gelieferte und beschädigte Mengen überschreiten den Plan.',
        reason: 'Bitte einen Abweichungsgrund angeben.',
        notShipped: 'Zuerst Kommissionierung und Warenausgang am Lieferschein abschließen.',
        gpsDisabled: 'GPS-Erfassung ist nicht aktiviert.',
        photo: 'Ein unterstütztes Foto bis 10 MB wählen.',
        routingMissing: 'Betreiber muss TOUR_ROUTING_BASE_URL einrichten',
        routingFailed: 'Routingdienst nicht erreichbar. Manuelle Planung bleibt möglich.',
        routingLimit: 'Die Tour überschreitet das konfigurierte Routinglimit.',
        openStops: 'Offene Stopps zuerst bestätigen oder als fehlgeschlagen dokumentieren.',
        status: 'Die Aktion passt nicht zum aktuellen Zustand.',
        duplicateLine: 'Jede Position genau einmal auswählen.',
        lines: 'Alle Stoppmengen ausdrücklich bestätigen.',
        order: 'Alle Stopps genau einmal anordnen.',
        replan:
          'Nur offene Mengen eines fehlgeschlagenen oder teilgelieferten Stopps erneut planen.',
        signature: 'Unterschrift ist keine gültige PNG-Datei.',
        proofPhotoImmutable:
          'Fotos eines bestätigten Liefernachweises bleiben unveränderlich erhalten.',
      },
      help: 'Hilfe zu Liefertouren',
      routingLimit: 'Maximale Stopps je Routinganfrage',
      timeZone: 'Zeitzone der Tourenplanung',
      cancelTour: 'Tour aufheben',
      removeStop: 'Stopp aus Planung nehmen',
      plannedArrival: 'Geplante Ankunft',
      notStored: 'Noch nicht lokal gespeichert',
      events: {
        CREATE: 'Erstellt',
        ASSIGN: 'Lieferung zugeordnet',
        ORDER: 'Reihenfolge geändert',
        PLAN: 'Fahrplan geprüft',
        START: 'Tour gestartet',
        EN_ROUTE: 'Unterwegs',
        ARRIVED: 'Angekommen',
        FAILED: 'Lieferung fehlgeschlagen',
        DELIVERY_PROOF: 'Liefernachweis gespeichert',
        CLOSE: 'Tour abgeschlossen',
        PICKING_ALLOCATION: 'Kommissionierung abgeglichen',
        UNASSIGN: 'Stopp aus Planung genommen',
        CANCEL: 'Tour aufgehoben',
      },
    },
  },
  en: {
    tours: {
      title: 'Delivery tours',
      driverTitle: 'My delivery tours',
      new: 'Create tour',
      name: 'Name',
      date: 'Date',
      driver: 'Driver',
      vehicle: 'Vehicle (optional)',
      capacity: 'Capacity in kg',
      packageCapacity: 'Package capacity',
      start: 'Start point',
      end: 'End point',
      latitude: 'Latitude',
      longitude: 'Longitude',
      departure: 'Departure time',
      empty: 'No tours yet.',
      loading: 'Loading tours…',
      retry: 'Reload',
      error: 'The action failed. Your entries are retained.',
      save: 'Save',
      saved: 'Saved',
      cancel: 'Cancel',
      open: 'Open',
      assign: 'Assign delivery',
      source: 'Order or delivery note',
      orderDraftHint:
        'Orders create a linked delivery draft. Pick and post goods issue before starting the tour.',
      quantity: 'Quantity in base unit',
      planned: 'Planned',
      delivered: 'Delivered',
      damaged: 'Damaged',
      reason: 'Discrepancy reason',
      notes: 'Notes',
      windowFrom: 'Receiving from',
      windowUntil: 'Receiving until',
      duration: 'Stop duration in minutes',
      up: 'Move stop up',
      down: 'Move stop down',
      optimize: 'Optimize order',
      check: 'Check plan',
      conflicts: 'Planning conflicts',
      startTour: 'Start tour',
      closeTour: 'Finish tour',
      enRoute: 'En route',
      arrived: 'Arrived',
      failed: 'Delivery failed',
      navigate: 'Open navigation',
      proof: 'Delivery confirmation',
      recipient: 'Recipient name',
      signature: 'Signature (optional)',
      clearSignature: 'Clear signature',
      photo: 'Add photo',
      photos: 'Photos',
      photoUnsent: 'Photo stored on this device · awaiting upload',
      photoUploaded: 'Photo uploaded · delivery proof not confirmed',
      photoNotStored: 'Photo not stored on this device. Keep this page open and retry or discard.',
      photoRetry: 'Store and retry photo',
      photoDiscard: 'Discard photo',
      photoStorageFailed:
        'Photos cannot be stored on this device. Check free space and browser settings; keep this page open.',
      photoLimit: 'Choose up to ten photos, each no larger than 10 MB.',
      proofStorageFailed:
        'The proof could not be stored on this device. Check free space and retry.',
      photoCleanupFailed: 'Delivery proof confirmed. Local photos could not be removed.',
      photosLoading: 'Restoring photos from this device …',
      gps: 'Capture location for this proof',
      saveLocal: 'Save on this device',
      unsent: 'Saved on this device · not submitted',
      confirmed: 'Delivery proof confirmed by server',
      submit: 'Submit delivery proof',
      noDoublePosting: 'Confirmation creates no additional stock issue or automatic invoice.',
      versionChanged: 'The tour changed. Review your entries and use the current version.',
      refreshVersion: 'Use current version',
      containers: 'Container returns',
      containerType: 'Container type',
      condition: 'Condition',
      GOOD: 'Good',
      DAMAGED: 'Damaged',
      history: 'History',
      settings: 'Warehouse and delivery workflows',
      manualRouting:
        'Manual planning needs no provider. Road travel times require an operator-managed or contracted OSRM service. The operator determines cost, map updates, vehicle profile and limits. No public demo service is used automatically.',
      routing: 'Road routing',
      routingReady: 'Routing service configured',
      routingMissing: 'Operator must configure TOUR_ROUTING_BASE_URL',
      gpsSetting: 'Allow GPS only by explicit action for delivery proof',
      statuses: {
        PLANNED: 'Planned',
        ACTIVE: 'Active',
        COMPLETED: 'Completed',
        CANCELLED: 'Cancelled',
        EN_ROUTE: 'En route',
        ARRIVED: 'Arrived',
        DELIVERED: 'Delivered',
        PARTIAL: 'Partially delivered',
        FAILED: 'Delivery failed',
      },
      planningConflicts: {
        MISSING_COORDINATES: 'Coordinates missing',
        ADDRESS_INCOMPLETE: 'Address incomplete',
        ROUTING_NOT_CONFIGURED: 'Road travel times unavailable',
        MISSING_DEPARTURE: 'Start point or departure time missing',
        TIME_WINDOW: 'Receiving time window exceeded',
        CAPACITY: 'Vehicle capacity exceeded',
        MISSING_WEIGHT: 'Weight data incomplete',
        MISSING_PACKAGES: 'Confirmed package total missing',
        ROUTE_UNREACHABLE: 'No road connection found',
      },
      errors: {
        driver: 'Driver requires delivery tour permission.',
        version: 'The tour changed. Review your entries and use the current version.',
        closed: 'This operation is closed.',
        started: 'An active tour cannot be replanned.',
        source: 'Choose a released order or open delivery note.',
        overAllocated: 'Quantity is already assigned to a tour.',
        assignedDocument:
          'This delivery note is assigned to a tour. Remove its stop from the plan before changing quantities, lots or delivery details. Picking remains available through the warehouse workflow.',
        overDelivered: 'Delivered and damaged quantities exceed the plan.',
        reason: 'Enter a discrepancy reason.',
        notShipped: 'Complete picking and goods issue on the delivery note first.',
        gpsDisabled: 'GPS capture is disabled.',
        photo: 'Choose a supported photo up to 10 MB.',
        routingMissing: 'Operator must configure TOUR_ROUTING_BASE_URL',
        routingFailed: 'Routing service unavailable. Manual planning remains available.',
        routingLimit: 'Tour exceeds the configured routing limit.',
        openStops: 'Confirm open stops or document failed delivery first.',
        status: 'Action is unavailable in the current state.',
        duplicateLine: 'Select each line once.',
        lines: 'Explicitly confirm every stop line.',
        order: 'Order every stop exactly once.',
        replan: 'Replan only outstanding quantities of failed or partial stops.',
        signature: 'Signature is not a valid PNG image.',
        proofPhotoImmutable: 'Photographs of acknowledged delivery proof remain immutable.',
      },
      help: 'Delivery tour help',
      routingLimit: 'Maximum stops per routing request',
      timeZone: 'Tour planning time zone',
      cancelTour: 'Cancel tour',
      removeStop: 'Remove planned stop',
      plannedArrival: 'Planned arrival',
      notStored: 'Not yet saved locally',
      events: {
        CREATE: 'Created',
        ASSIGN: 'Delivery assigned',
        ORDER: 'Order changed',
        PLAN: 'Plan checked',
        START: 'Tour started',
        EN_ROUTE: 'En route',
        ARRIVED: 'Arrived',
        FAILED: 'Delivery failed',
        DELIVERY_PROOF: 'Proof saved',
        CLOSE: 'Tour closed',
        PICKING_ALLOCATION: 'Picking reconciled',
        UNASSIGN: 'Planned stop removed',
        CANCEL: 'Tour cancelled',
      },
    },
  },
  fr: {
    tours: {
      title: 'Livraisons en tournée',
      driverTitle: 'Mes tournées',
      new: 'Créer une tournée',
      name: 'Nom',
      date: 'Date',
      driver: 'Chauffeur',
      vehicle: 'Véhicule (facultatif)',
      capacity: 'Capacité en kg',
      packageCapacity: 'Capacité en emballages',
      start: 'Point de départ',
      end: 'Point final',
      latitude: 'Latitude',
      longitude: 'Longitude',
      departure: 'Heure de départ',
      empty: 'Aucune tournée.',
      loading: 'Chargement des tournées…',
      retry: 'Recharger',
      error: 'Échec de l’action. Vos données sont conservées.',
      save: 'Enregistrer',
      saved: 'Enregistré',
      cancel: 'Annuler',
      open: 'Ouvrir',
      assign: 'Affecter une livraison',
      source: 'Commande ou bon de livraison',
      orderDraftHint:
        'Les commandes créent un bon de livraison lié. Préparez et comptabilisez la sortie avant le départ.',
      quantity: 'Quantité en unité de base',
      planned: 'Prévu',
      delivered: 'Livré',
      damaged: 'Endommagé',
      reason: 'Motif de l’écart',
      notes: 'Notes',
      windowFrom: 'Réception à partir de',
      windowUntil: 'Réception jusqu’à',
      duration: 'Durée du séjour en minutes',
      up: 'Monter l’arrêt',
      down: 'Descendre l’arrêt',
      optimize: 'Optimiser l’ordre',
      check: 'Vérifier le plan',
      conflicts: 'Conflits du plan',
      startTour: 'Démarrer la tournée',
      closeTour: 'Terminer la tournée',
      enRoute: 'En route',
      arrived: 'Arrivé',
      failed: 'Livraison échouée',
      navigate: 'Ouvrir la navigation',
      proof: 'Confirmation de livraison',
      recipient: 'Nom du destinataire',
      signature: 'Signature (facultative)',
      clearSignature: 'Effacer la signature',
      photo: 'Ajouter une photo',
      photos: 'Photos',
      photoUnsent: 'Photo enregistrée sur cet appareil · en attente de transfert',
      photoUploaded: 'Photo transférée · preuve de livraison non confirmée',
      photoNotStored:
        'Photo non enregistrée sur cet appareil. Gardez cette page ouverte et réessayez ou supprimez-la.',
      photoRetry: 'Enregistrer et retransférer la photo',
      photoDiscard: 'Supprimer la photo',
      photoStorageFailed:
        'Impossible de conserver les photos sur cet appareil. Vérifiez l’espace libre et le navigateur ; gardez cette page ouverte.',
      photoLimit: 'Sélectionnez au plus dix photos de 10 Mo chacune.',
      proofStorageFailed:
        'Impossible de conserver la preuve sur cet appareil. Vérifiez l’espace libre et réessayez.',
      photoCleanupFailed:
        'Preuve de livraison confirmée. Les photos locales n’ont pas pu être supprimées.',
      photosLoading: 'Restauration des photos de cet appareil …',
      gps: 'Enregistrer la position pour cette preuve',
      saveLocal: 'Enregistrer sur cet appareil',
      unsent: 'Enregistré sur cet appareil · non transmis',
      confirmed: 'Preuve confirmée par le serveur',
      submit: 'Transmettre la preuve',
      noDoublePosting: 'La confirmation ne crée ni nouvelle sortie ni facture automatique.',
      versionChanged: 'La tournée a changé. Vérifiez vos données et utilisez la version actuelle.',
      refreshVersion: 'Utiliser la version actuelle',
      containers: 'Retours d’emballages',
      containerType: 'Type d’emballage',
      condition: 'État',
      GOOD: 'Bon état',
      DAMAGED: 'Endommagé',
      history: 'Historique',
      settings: 'Entrepôt et livraisons',
      manualRouting:
        'La planification manuelle fonctionne sans fournisseur. Les temps routiers nécessitent un service OSRM exploité ou sous contrat. L’exploitant définit coûts, cartes, profil et limites. Aucun service de démonstration n’est utilisé automatiquement.',
      routing: 'Routage routier',
      routingReady: 'Service configuré',
      routingMissing: 'L’exploitant doit configurer TOUR_ROUTING_BASE_URL',
      gpsSetting: 'Autoriser le GPS uniquement sur action explicite pour la preuve',
      statuses: {
        PLANNED: 'Planifié',
        ACTIVE: 'Actif',
        COMPLETED: 'Terminé',
        CANCELLED: 'Annulé',
        EN_ROUTE: 'En route',
        ARRIVED: 'Arrivé',
        DELIVERED: 'Livré',
        PARTIAL: 'Partiellement livré',
        FAILED: 'Livraison échouée',
      },
      planningConflicts: {
        MISSING_COORDINATES: 'Coordonnées manquantes',
        ADDRESS_INCOMPLETE: 'Adresse incomplète',
        ROUTING_NOT_CONFIGURED: 'Temps routiers indisponibles',
        MISSING_DEPARTURE: 'Départ ou heure manquants',
        TIME_WINDOW: 'Fenêtre de réception dépassée',
        CAPACITY: 'Capacité dépassée',
        MISSING_WEIGHT: 'Poids incomplet',
        MISSING_PACKAGES: 'Total confirmé manquant',
        ROUTE_UNREACHABLE: 'Aucune liaison routière',
      },
      errors: {
        driver: 'Le chauffeur doit être autorisé.',
        version: 'La tournée a changé. Vérifiez vos données et utilisez la version actuelle.',
        closed: 'Cette opération est terminée.',
        started: 'Une tournée active ne peut être modifiée.',
        source: 'Choisissez une commande validée ou un bon ouvert.',
        overAllocated: 'La quantité est déjà affectée.',
        assignedDocument:
          'Ce bon de livraison est affecté à une tournée. Retirez son arrêt du planning avant de modifier les quantités, les lots ou les données de livraison. La préparation reste disponible dans le processus d’entrepôt.',
        overDelivered: 'Les quantités dépassent le prévu.',
        reason: 'Indiquez un motif.',
        notShipped: 'Terminez préparation et sortie du bon.',
        gpsDisabled: 'Le GPS est désactivé.',
        photo: 'Choisissez une photo compatible de 10 Mo maximum.',
        routingMissing: 'L’exploitant doit configurer TOUR_ROUTING_BASE_URL',
        routingFailed: 'Service indisponible. La planification manuelle reste possible.',
        routingLimit: 'La tournée dépasse la limite.',
        openStops: 'Confirmez les arrêts ouverts ou l’échec.',
        status: 'Action impossible dans cet état.',
        duplicateLine: 'Sélectionnez chaque ligne une fois.',
        lines: 'Confirmez chaque ligne de l’arrêt.',
        order: 'Ordonnez chaque arrêt une fois.',
        replan: 'Replanifiez uniquement les quantités ouvertes.',
        signature: 'La signature n’est pas une image PNG valide.',
        proofPhotoImmutable: 'Les photos d’une preuve confirmée restent immuables.',
      },
      help: 'Aide sur les tournées',
      routingLimit: 'Arrêts maximum par requête',
      timeZone: 'Fuseau horaire des tournées',
      cancelTour: 'Annuler la tournée',
      removeStop: 'Retirer l’arrêt planifié',
      plannedArrival: 'Arrivée prévue',
      notStored: 'Pas encore enregistré localement',
      events: {
        CREATE: 'Créée',
        ASSIGN: 'Livraison assignée',
        ORDER: 'Ordre modifié',
        PLAN: 'Plan vérifié',
        START: 'Tournée démarrée',
        EN_ROUTE: 'En route',
        ARRIVED: 'Arrivé',
        FAILED: 'Échec de livraison',
        DELIVERY_PROOF: 'Preuve enregistrée',
        CLOSE: 'Tournée clôturée',
        PICKING_ALLOCATION: 'Préparation rapprochée',
        UNASSIGN: 'Arrêt retiré',
        CANCEL: 'Tournée annulée',
      },
    },
  },
  es: {
    tours: {
      title: 'Rutas de entrega',
      driverTitle: 'Mis rutas',
      new: 'Crear ruta',
      name: 'Nombre',
      date: 'Fecha',
      driver: 'Conductor',
      vehicle: 'Vehículo (opcional)',
      capacity: 'Capacidad en kg',
      packageCapacity: 'Capacidad de envases',
      start: 'Punto de partida',
      end: 'Punto final',
      latitude: 'Latitud',
      longitude: 'Longitud',
      departure: 'Hora de salida',
      empty: 'No hay rutas.',
      loading: 'Cargando rutas…',
      retry: 'Volver a cargar',
      error: 'La acción falló. Sus datos se conservan.',
      save: 'Guardar',
      saved: 'Guardado',
      cancel: 'Cancelar',
      open: 'Abrir',
      assign: 'Asignar entrega',
      source: 'Pedido o albarán',
      orderDraftHint:
        'Los pedidos crean un albarán vinculado. Prepare y contabilice la salida antes de iniciar la ruta.',
      quantity: 'Cantidad en unidad base',
      planned: 'Previsto',
      delivered: 'Entregado',
      damaged: 'Dañado',
      reason: 'Motivo de la diferencia',
      notes: 'Notas',
      windowFrom: 'Recepción desde',
      windowUntil: 'Recepción hasta',
      duration: 'Parada en minutos',
      up: 'Subir parada',
      down: 'Bajar parada',
      optimize: 'Optimizar orden',
      check: 'Comprobar plan',
      conflicts: 'Conflictos del plan',
      startTour: 'Iniciar ruta',
      closeTour: 'Finalizar ruta',
      enRoute: 'En camino',
      arrived: 'Llegado',
      failed: 'Entrega fallida',
      navigate: 'Abrir navegación',
      proof: 'Confirmación de entrega',
      recipient: 'Nombre del receptor',
      signature: 'Firma (opcional)',
      clearSignature: 'Borrar firma',
      photo: 'Añadir foto',
      photos: 'Fotos',
      photoUnsent: 'Foto guardada en este dispositivo · pendiente de carga',
      photoUploaded: 'Foto cargada · comprobante de entrega sin confirmar',
      photoNotStored:
        'Foto no guardada en este dispositivo. Mantenga esta página abierta y reintente o descarte.',
      photoRetry: 'Guardar y reenviar foto',
      photoDiscard: 'Descartar foto',
      photoStorageFailed:
        'No se pueden guardar fotos en este dispositivo. Revise el espacio libre y el navegador; mantenga esta página abierta.',
      photoLimit: 'Seleccione hasta diez fotos de un máximo de 10 MB cada una.',
      proofStorageFailed:
        'No se pudo guardar el comprobante en este dispositivo. Revise el espacio libre y reintente.',
      photoCleanupFailed: 'Comprobante confirmado. No se pudieron eliminar las fotos locales.',
      photosLoading: 'Restaurando fotos de este dispositivo …',
      gps: 'Registrar ubicación para esta prueba',
      saveLocal: 'Guardar en este dispositivo',
      unsent: 'Guardado en este dispositivo · sin enviar',
      confirmed: 'Prueba confirmada por el servidor',
      submit: 'Enviar prueba de entrega',
      noDoublePosting: 'La confirmación no genera otra salida ni factura automática.',
      versionChanged: 'La ruta cambió. Revise los datos y use la versión actual.',
      refreshVersion: 'Usar versión actual',
      containers: 'Devoluciones de envases',
      containerType: 'Tipo de envase',
      condition: 'Estado',
      GOOD: 'Buen estado',
      DAMAGED: 'Dañado',
      history: 'Historial',
      settings: 'Almacén y entregas',
      manualRouting:
        'La planificación manual funciona sin proveedor. Los tiempos requieren OSRM propio o contratado. El operador define costes, mapas, perfil y límites. No se utiliza automáticamente un servicio de demostración.',
      routing: 'Rutas por carretera',
      routingReady: 'Servicio configurado',
      routingMissing: 'El operador debe configurar TOUR_ROUTING_BASE_URL',
      gpsSetting: 'Permitir GPS solo por acción explícita para la prueba',
      statuses: {
        PLANNED: 'Planificado',
        ACTIVE: 'Activo',
        COMPLETED: 'Finalizado',
        CANCELLED: 'Cancelado',
        EN_ROUTE: 'En camino',
        ARRIVED: 'Llegado',
        DELIVERED: 'Entregado',
        PARTIAL: 'Entrega parcial',
        FAILED: 'Entrega fallida',
      },
      planningConflicts: {
        MISSING_COORDINATES: 'Faltan coordenadas',
        ADDRESS_INCOMPLETE: 'Dirección incompleta',
        ROUTING_NOT_CONFIGURED: 'Tiempos por carretera no disponibles',
        MISSING_DEPARTURE: 'Falta origen u hora de salida',
        TIME_WINDOW: 'Ventana de recepción excedida',
        CAPACITY: 'Capacidad excedida',
        MISSING_WEIGHT: 'Peso incompleto',
        MISSING_PACKAGES: 'Falta total confirmado de envases',
        ROUTE_UNREACHABLE: 'No hay conexión por carretera',
      },
      errors: {
        driver: 'El conductor requiere permiso.',
        version: 'La ruta cambió. Revise los datos y use la versión actual.',
        closed: 'Esta operación está cerrada.',
        started: 'No se puede replanificar una ruta activa.',
        source: 'Elija un pedido aprobado o albarán abierto.',
        overAllocated: 'Cantidad ya asignada a una ruta.',
        assignedDocument:
          'Este albarán está asignado a una ruta. Retire su parada del plan antes de cambiar cantidades, lotes o datos de entrega. La preparación sigue disponible mediante el proceso de almacén.',
        overDelivered: 'Las cantidades superan el plan.',
        reason: 'Indique un motivo.',
        notShipped: 'Complete preparación y salida en el albarán.',
        gpsDisabled: 'GPS desactivado.',
        photo: 'Seleccione foto compatible hasta 10 MB.',
        routingMissing: 'El operador debe configurar TOUR_ROUTING_BASE_URL',
        routingFailed: 'Servicio no disponible. Planificación manual disponible.',
        routingLimit: 'La ruta supera el límite configurado.',
        openStops: 'Confirme paradas abiertas o documente fallos.',
        status: 'Acción no disponible en este estado.',
        duplicateLine: 'Seleccione cada línea una vez.',
        lines: 'Confirme cada línea de parada.',
        order: 'Ordene cada parada una vez.',
        replan: 'Replanifique solo cantidades pendientes.',
        signature: 'La firma no es una imagen PNG válida.',
        proofPhotoImmutable: 'Las fotos de un comprobante confirmado son inmutables.',
      },
      help: 'Ayuda de rutas',
      routingLimit: 'Paradas máximas por petición',
      timeZone: 'Zona horaria de las rutas',
      cancelTour: 'Cancelar ruta',
      removeStop: 'Retirar parada prevista',
      plannedArrival: 'Llegada prevista',
      notStored: 'Aún sin guardar localmente',
      events: {
        CREATE: 'Creada',
        ASSIGN: 'Entrega asignada',
        ORDER: 'Orden modificado',
        PLAN: 'Plan revisado',
        START: 'Ruta iniciada',
        EN_ROUTE: 'En camino',
        ARRIVED: 'Llegada',
        FAILED: 'Entrega fallida',
        DELIVERY_PROOF: 'Comprobante guardado',
        CLOSE: 'Ruta cerrada',
        PICKING_ALLOCATION: 'Preparación conciliada',
        UNASSIGN: 'Parada retirada',
        CANCEL: 'Ruta cancelada',
      },
    },
  },
  tr: {
    tours: {
      title: 'Teslimat turları',
      driverTitle: 'Teslimat turlarım',
      new: 'Tur oluştur',
      name: 'Ad',
      date: 'Tarih',
      driver: 'Sürücü',
      vehicle: 'Araç (isteğe bağlı)',
      capacity: 'Kapasite kg',
      packageCapacity: 'Ambalaj kapasitesi',
      start: 'Başlangıç noktası',
      end: 'Bitiş noktası',
      latitude: 'Enlem',
      longitude: 'Boylam',
      departure: 'Hareket saati',
      empty: 'Henüz tur yok.',
      loading: 'Turlar yükleniyor…',
      retry: 'Yeniden yükle',
      error: 'İşlem başarısız. Girişleriniz korunur.',
      save: 'Kaydet',
      saved: 'Kaydedildi',
      cancel: 'İptal',
      open: 'Aç',
      assign: 'Teslimat ata',
      source: 'Sipariş veya irsaliye',
      orderDraftHint:
        'Siparişler bağlı irsaliye taslağı oluşturur. Turdan önce toplayıp stok çıkışını kaydedin.',
      quantity: 'Temel birim miktarı',
      planned: 'Planlanan',
      delivered: 'Teslim edilen',
      damaged: 'Hasarlı',
      reason: 'Fark nedeni',
      notes: 'Notlar',
      windowFrom: 'Kabul başlangıcı',
      windowUntil: 'Kabul bitişi',
      duration: 'Durak süresi dakika',
      up: 'Durağı yukarı taşı',
      down: 'Durağı aşağı taşı',
      optimize: 'Sırayı iyileştir',
      check: 'Planı kontrol et',
      conflicts: 'Plan sorunları',
      startTour: 'Turu başlat',
      closeTour: 'Turu bitir',
      enRoute: 'Yolda',
      arrived: 'Varıldı',
      failed: 'Teslimat başarısız',
      navigate: 'Navigasyonu aç',
      proof: 'Teslimat onayı',
      recipient: 'Alıcı adı',
      signature: 'İmza (isteğe bağlı)',
      clearSignature: 'İmzayı sil',
      photo: 'Fotoğraf ekle',
      photos: 'Fotoğraflar',
      photoUnsent: 'Fotoğraf bu cihazda saklandı · yükleme bekleniyor',
      photoUploaded: 'Fotoğraf yüklendi · teslimat kanıtı henüz onaylanmadı',
      photoNotStored:
        'Fotoğraf bu cihazda saklanmadı. Sayfayı açık tutun ve yeniden deneyin veya silin.',
      photoRetry: 'Fotoğrafı sakla ve yeniden yükle',
      photoDiscard: 'Fotoğrafı sil',
      photoStorageFailed:
        'Fotoğraflar bu cihazda saklanamıyor. Boş alanı ve tarayıcı ayarlarını kontrol edin; sayfayı açık tutun.',
      photoLimit: 'Her biri en fazla 10 MB olan en çok on fotoğraf seçin.',
      proofStorageFailed:
        'Kanıt bu cihazda saklanamadı. Boş alanı kontrol edin ve yeniden deneyin.',
      photoCleanupFailed: 'Teslimat kanıtı onaylandı. Yerel fotoğraflar silinemedi.',
      photosLoading: 'Bu cihazdaki fotoğraflar geri yükleniyor …',
      gps: 'Bu kanıt için konumu kaydet',
      saveLocal: 'Bu cihazda kaydet',
      unsent: 'Bu cihazda kayıtlı · gönderilmedi',
      confirmed: 'Sunucu tarafından onaylanan teslimat kanıtı',
      submit: 'Teslimat kanıtını gönder',
      noDoublePosting: 'Onay ek stok çıkışı veya otomatik fatura oluşturmaz.',
      versionChanged: 'Tur değişti. Girişleri gözden geçirip güncel sürümü kullanın.',
      refreshVersion: 'Güncel sürümü kullan',
      containers: 'Ambalaj iadeleri',
      containerType: 'Ambalaj türü',
      condition: 'Durum',
      GOOD: 'Sağlam',
      DAMAGED: 'Hasarlı',
      history: 'Geçmiş',
      settings: 'Depo ve teslimat iş akışları',
      manualRouting:
        'Manuel planlama sağlayıcısız çalışır. Yol süreleri işletmecinin yönettiği veya sözleşmeli OSRM hizmeti gerektirir. Maliyet, harita, araç profili ve sınırları işletmeci belirler. Genel demo hizmeti otomatik kullanılmaz.',
      routing: 'Yol yönlendirmesi',
      routingReady: 'Yönlendirme yapılandırıldı',
      routingMissing: 'İşletmeci TOUR_ROUTING_BASE_URL yapılandırmalı',
      gpsSetting: 'GPS yalnızca teslimat kanıtında açık işlemle izinli',
      statuses: {
        PLANNED: 'Planlandı',
        ACTIVE: 'Etkin',
        COMPLETED: 'Tamamlandı',
        CANCELLED: 'İptal edildi',
        EN_ROUTE: 'Yolda',
        ARRIVED: 'Varıldı',
        DELIVERED: 'Teslim edilen',
        PARTIAL: 'Kısmen teslim edildi',
        FAILED: 'Teslimat başarısız',
      },
      planningConflicts: {
        MISSING_COORDINATES: 'Koordinatlar eksik',
        ADDRESS_INCOMPLETE: 'Adres eksik',
        ROUTING_NOT_CONFIGURED: 'Yol süreleri mevcut değil',
        MISSING_DEPARTURE: 'Başlangıç veya hareket saati eksik',
        TIME_WINDOW: 'Kabul zaman aralığı aşıldı',
        CAPACITY: 'Araç kapasitesi aşıldı',
        MISSING_WEIGHT: 'Ağırlık verileri eksik',
        MISSING_PACKAGES: 'Onaylı ambalaj toplamı eksik',
        ROUTE_UNREACHABLE: 'Yol bağlantısı bulunamadı',
      },
      errors: {
        driver: 'Sürücü tur yetkisine ihtiyaç duyar.',
        version: 'Tur değişti. Girişleri gözden geçirip güncel sürümü kullanın.',
        closed: 'Bu işlem kapalı.',
        started: 'Etkin tur yeniden planlanamaz.',
        source: 'Onaylı sipariş veya açık irsaliye seçin.',
        overAllocated: 'Miktar bir tura atanmış.',
        assignedDocument:
          'Bu irsaliye bir tura atanmış. Miktarları, partileri veya teslimat bilgilerini değiştirmeden önce durağı plandan çıkarın. Toplama işlemi depo iş akışı üzerinden kullanılabilir.',
        overDelivered: 'Teslim edilen ve hasarlı miktarlar planı aşıyor.',
        reason: 'Fark nedeni girin.',
        notShipped: 'Önce irsaliye toplama ve stok çıkışını tamamlayın.',
        gpsDisabled: 'GPS kaydı kapalı.',
        photo: 'En fazla 10 MB desteklenen fotoğraf seçin.',
        routingMissing: 'İşletmeci TOUR_ROUTING_BASE_URL yapılandırmalı',
        routingFailed: 'Yönlendirme hizmeti yok. Manuel planlama kullanılabilir.',
        routingLimit: 'Tur yapılandırılan sınırı aşıyor.',
        openStops: 'Açık durakları onaylayın veya başarısızlığı belgeleyin.',
        status: 'İşlem mevcut durumda kullanılamaz.',
        duplicateLine: 'Her kalemi bir kez seçin.',
        lines: 'Her durak kalemini açıkça onaylayın.',
        order: 'Her durağı bir kez sıralayın.',
        replan: 'Yalnızca başarısız veya kısmi durakların açık miktarlarını planlayın.',
        signature: 'İmza geçerli bir PNG görüntüsü değil.',
        proofPhotoImmutable: 'Onaylanmış teslimat kanıtının fotoğrafları değiştirilemez.',
      },
      help: 'Teslimat turu yardımı',
      routingLimit: 'Yönlendirme başına azami durak',
      timeZone: 'Tur planlama saat dilimi',
      cancelTour: 'Turu iptal et',
      removeStop: 'Planlanan durağı çıkar',
      plannedArrival: 'Planlanan varış',
      notStored: 'Henüz yerel olarak kaydedilmedi',
      events: {
        CREATE: 'Oluşturuldu',
        ASSIGN: 'Teslimat atandı',
        ORDER: 'Sıra değiştirildi',
        PLAN: 'Plan kontrol edildi',
        START: 'Tur başladı',
        EN_ROUTE: 'Yolda',
        ARRIVED: 'Varıldı',
        FAILED: 'Teslimat başarısız',
        DELIVERY_PROOF: 'Kanıt kaydedildi',
        CLOSE: 'Tur kapandı',
        PICKING_ALLOCATION: 'Toplama eşleştirildi',
        UNASSIGN: 'Durak çıkarıldı',
        CANCEL: 'Tur iptal edildi',
      },
    },
  },
} satisfies Record<SupportedLocale, unknown>;
